import axios from "axios"
import { useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

function AuthProvider() {
    const navigate = useNavigate()
    const email = localStorage.getItem('email')
    const valoreSalvato = localStorage.getItem('idUser')

    useEffect(() => {
        const auth = async () => {
            try {
                await axios.get(`/verifyToken/${email}`).then(
                    res => {
                        if (res.data.message === 'not Authorized') {//refresh token scaduto
                            localStorage.clear()
                            localStorage.setItem('idUser', valoreSalvato)
                            window.scrollTo(0, 10)
                            setTimeout(() => { navigate('/') }, 500)
                        }
                        else {//verifico se token di accesso è validato con l'email e con il ticket                 
                            const decoded = jwtDecode(res.data.accessToken)
                            if (decoded.email !== localStorage.getItem('email') ||
                                decoded.ticket !== 'ahdfjkUYhnkjf8734Jjndkj?jfjejj(teowklIu') {
                                localStorage.clear()
                                localStorage.setItem('idUser', valoreSalvato)
                                window.scrollTo(0, 10)
                                navigate('/login')
                            }
                        }
                    }
                )
            } catch (err) { console.log(err) }
        }
        auth()
    }, [])
}
export default AuthProvider